import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useAtomValue } from "jotai";

import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import { newToastEvent } from "../../../utils/ToastUtil";
import CloudAppAPI from "../../api/CloudAppAPI";

const useModifyCloudApp = () => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queryClient = useQueryClient();
  const { tenantID }: any = useParams();

  const modifyCloudApp = useMutation({
    mutationFn: async (params: {
      payload: any;
      appID: string;
      onSuccess?: () => void;
    }) => {
      const { payload, appID } = params;

      return CloudAppAPI.modifyCloudApp(appID, payload, workspaceID);
    },
    onSuccess: (response, params) => {
      const { onSuccess } = params;

      const cloudApp = response.data.data.app;
      const updatedWorkspace = response.data.data.workspace;

      queryClient.setQueryData(["workspace", workspaceID], (data: any) => ({
        ...data,
        workspace: updatedWorkspace,
      }));

      queryClient.invalidateQueries({
        queryKey: ["workspaces", tenantID],
      });

      queryClient.setQueryData(
        ["cloudApp", tenantID, cloudApp?.id],
        (data: any) => {
          return {
            ...(data || {}),
            ...cloudApp,
          };
        }
      );

      newToastEvent("success", "Successfully updated app.");
      callFunctionIfExists(onSuccess);
    },
    onError: (e: any) => {
      newToastEvent("error", e?.response?.data?.message);
    },
  });

  return {
    modifyCloudApp: modifyCloudApp.mutate,
    modifyAppSubmitting: modifyCloudApp.isPending,
    error: modifyCloudApp.isError,
  };
};

export default useModifyCloudApp;
